import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";

// import JS files
import MuiModal from "../../../shares/MuiModal";
import MuiTextField from "../../../shares/MuiTextField";
import MuiButton from "../../../shares/MuiButton";
import useFetch from "../../../../context/useFetch";

// import Others files

const AddCity = (props) => {
  let windowWidth = window.screen.width;

  const [CityName, setCityName] = useState("");

  const AddCityApi = useFetch({
    method: "post",
    url: "City_Service",

    trigger: false,
    data: { name: CityName },
    // caller: props.getFunc,
    argFunc: (res) => {
      if ("name" in res) {
        toast.error("شهر با این نام وجود دارد", {
          position: toast.POSITION.TOP_CENTER,
        });
      } else {
        setCityName("");
        props.getFunc.reFetch();
        // toast.success("شهر موردنظر با موفقیت ایجاد شد", {
        //   position: toast.POSITION.TOP_CENTER,
        // });
        props.setOpenModal(false);
      }
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  return (
    <>
      <MuiModal
        openModal={props.openModal}
        setOpenModal={props.setOpenModal}
        width="w-2/5"
        isOverflow={true}
        isNotBackdropClick={true}
      >
        <div>
          <div className="close-modal-icon">
            <CloseIcon
              onClick={() => props.setOpenModal(false)}
              fontSize="large"
              color="secondary"
            />
          </div>
          <div className="mt-4">
            <span className="text-xs md:text-sm text-gray-700">
              نام شهر موردنظر خود را وارد کنید.
            </span>
            <div className="mt-4">
              <MuiTextField
                onChange={(e) => setCityName(e.target.value)}
                id="outlined-basic"
                label="نام"
                variant="outlined"
                size="small"
                value={CityName}
                autoFocus
              />
            </div>
            <div className="flex justify-end mt-4">
              <MuiButton
                onClick={AddCityApi.reFetch}
                variant="contained"
                color="success"
                text="ایجاد"
                disabled={(CityName == "") | AddCityApi.loading}
              />
            </div>
          </div>
        </div>
      </MuiModal>
    </>
  );
};

export default AddCity;
